<template>
    <div id="login">
        <div>
            <h1>Wilkommen bei Elisabot</h1>
        </div>
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Loading...</p>
            </div>
        </transition>

        <section class="forms">
            <div class="login-form" v-if="loginActive">
                <div class="tabs">
                    <div class="heading a active">Einloggen</div>
                    <div class="heading b" @click="loginActive=false">Neuen Account anlegen</div>
                </div>
                <form @submit.prevent>
                    <div class="form-element">
                        <label for="email1">Email</label>
                        <input v-model.trim="loginForm.email" type="text" placeholder="you@email.com" id="email1" autocomplete="username" />
                    </div>
                    <div class="form-element">
                        <label for="password1">Passwort</label>
                        <input v-model.trim="loginForm.password" type="password" placeholder="******" id="password1" autocomplete="current-password"/>
                    </div>
                </form>
                <div class="login-buttons">
                  <button 
                    @click="login" 
                    class="button login"
                    :class="{ 'disabled': loginForm.email === '' }"
                  >Log In</button>
                  <button 
                    @click="forgotPassword" 
                    class="button login" 
                    :class="{ 'disabled': loginForm.email === '' }"
                  >Passwort vergessen</button>
                </div>
            </div>
        
            <div class="login-form" v-else>
                <form @submit.prevent>
                    <div class="tabs">
                        <div class="heading a" @click="loginActive=true" >Einloggen</div>
                        <div class="heading b active">Neuen Account anlegen</div>
                    </div>
                    
                    <div class="form-element">
                        <label for="name">Name:</label>
                        <input v-model.trim="signupForm.name" type="text" placeholder="Name" id="name" autocomplete="name"/>
                    </div>
                  
                    <div class="form-element">
                        <label for="title">Titel:</label>
                        <input v-model.trim="signupForm.title" type="text" placeholder="Titel" id="title" />
                    </div>

                    <div class="form-element">
                        <label for="email2">E-mail:</label>
                        <input v-model.trim="signupForm.email" type="text" placeholder="you@email.com" id="email2" autocomplete="e-mail"/>
                    </div>

                    <div class="form-element">
                        <label for="password2">Passwort:</label>
                        <input v-model.trim="signupForm.password" type="password" placeholder="min 6 Zeichen" id="password2" autocomplete="current-password" />
                    </div>
                </form>
                <button @click="signup" class="button login">Account anlegen</button>
            </div>
    </section>
     <transition name="fade">
            <div v-if="errorMsg !== ''" class="error-msg">
                <p>{{ errorMsg }}</p>
             </div>
    </transition>
    </div>
</template>

<script>
const fb = require("../fbConfig.js");
export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",
        title: "",
        email: "",
        password: ""
      },
      loginActive: true,
      performingRequest: false,
      errorMsg: "",
      allowedUsers: [
        "soph@blablabla.com",
        "instantsophie@gmail.com",
        "eva.hammer@hammer-gmbh.at",
        "m.kurz@hammer-gmbh.at",
        "testuser@test.com",
        "lisa.aichhorn@hammer-gmbh.at",
        "lorenz@crew8.at",
        "anthony@ejidike.com"
      ]
    };
  },
  methods: {
    forgotPassword() {
      fb.auth
        .sendPasswordResetEmail(this.loginForm.email)
        .then(() => {
          this.errorMsg = "Email sent";
        })
        .catch(err => {
          console.log(err);
          this.errorMsg = err.message;
        });
    },
    login() {
      this.performingRequest = true;
      if (this.allowedUsers.includes(this.loginForm.email)) {
        fb.auth
          .signInWithEmailAndPassword(
            this.loginForm.email,
            this.loginForm.password
          )
          .then(user => {
            this.$store.commit("setCurrentUser", user.user);
            this.$store.dispatch("fetchUserProfile");
            this.$router.push("/baustellen");
          })
          .catch(err => {
            console.log(err);
            this.performingRequest = false;
            this.errorMsg = err.message;
          });
      } else {
        this.performingRequest = false;
        this.errorMsg = "Nicht autorisiert";
      }
    },
    signup() {
      this.performingRequest = true;
      if (this.allowedUsers.includes(this.signupForm.email)) {
        fb.auth
          .createUserWithEmailAndPassword(
            this.signupForm.email,
            this.signupForm.password
          )
          .then(credential => {
            this.$store.commit("setCurrentUser", credential.user);
            // create user obj
            fb.users
              .doc(credential.user.uid)
              .set({
                name: this.signupForm.name,
                title: this.signupForm.title
              })
              .then(() => {
                this.$store.dispatch("fetchUserProfile");
                this.performingRequest = false;
                this.$router.push("/dashboard");
              })
              .catch(err => {
                console.log(err);
                this.performingRequest = false;
                this.errorMsg = err.message;
              });
          })
          .catch(err => {
            console.log(err);
            this.performingRequest = false;
            this.errorMsg = err.message;
          });
      } else {
        this.performingRequest = false;
        this.errorMsg = "Nicht autorisiert";
      }
    }
  }
};
</script>

<style scoped>
#login {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.forms {
  margin-top: 100px;
  display: flex;
}

.form-element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.login-form {
  background: #eeeeee;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 370px;
}

.tabs {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: bold;
  background: #2c3e50;
  color: #eeeeee;
  border-radius: 10px 10px 0 0;
  margin-bottom: 40px;
}

.heading {
  padding: 20px;
  cursor: pointer;
  font-size: 17px;
}

.a {
  border-radius: 9px 0 0 0;
}

.b {
  border-radius: 0 9px 0 0;
}

.active {
  background: #eeeeee;
  color: #2c3e50;
  cursor: auto;
}

h2 {
  margin-top: 0;
}

input {
  margin: 10px;
  box-sizing: border-box;
  padding: 5px;
  border: 1px solid #2c3e50;
  outline: none;
  border: none;
  border-radius: 20px;
  padding: 10px;
  width: 250px;
  font-family: "Avenir";
}

.login {
  height: 35px;
  width: 50%;
  margin: 20px auto 20px auto;
}

.error-msg {
  font-weight: bold;
  font-size: 1.5em;
  color: rgb(165, 42, 42);
}

.login-buttons {
  margin: 0 20px;
  display: flex;
  gap: 10px;
}

.disabled {
  background: #ccc;
  pointer-events: none;
  border: none;
}
</style>
